export const siteVisitRecordingSessionSchema = {
	title: 'Site visit recording session',
	description: 'Local session metadata for site visit audio recording (Add New Visit flow)',
	version: 0,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 200,
			primary: true,
		},
		siteId: {
			type: ['number', 'null'],
			description: 'Site lead id (siteOverview.id), not sitenumber_c',
		},
		status: {
			type: 'string',
			maxLength: 24,
		},
		accumulatedMs: {
			type: 'number',
		},
		runningSince: {
			type: ['number', 'null'],
		},
		recordingStartedAt: {
			type: ['number', 'null'],
		},
		completedAt: {
			type: ['number', 'null'],
		},
		finalDurationMs: {
			type: ['number', 'null'],
		},
		chunkCount: {
			type: 'number',
		},
		totalBytes: {
			type: 'number',
		},
		mimeType: {
			type: ['string', 'null'],
		},
		updatedAt: {
			type: 'number',
		},
		uploadOnStop: {
			type: 'boolean',
		},
	},
	required: [
		'id',
		'siteId',
		'status',
		'accumulatedMs',
		'runningSince',
		'recordingStartedAt',
		'completedAt',
		'finalDurationMs',
		'chunkCount',
		'totalBytes',
		'mimeType',
		'updatedAt',
		'uploadOnStop',
	],
};
